module.exports = __webpack_public_path__ + "img/antes_despues_213.07bd325f.png";